import React from 'react';
import gql from 'graphql-tag';
import { Query } from 'react-apollo';
import { Switch, Route } from 'react-router-dom';
import { components } from '@peachjar/components';
import qs from 'qs';

import { transformRegistrationStatus } from './StepsGenerator';
import { SetupOrganizationContainer } from '../organization/index';
import SetupStaffContainer from '../staff/index';
import { SetupSchoolContainer } from '../school/index';
import SetupParentContainer from '../parent/index';
import ConfirmSetupContainer from '../confirm/index';

const { Stepper } = components;
const { Spinner } = components.LoadingIndicators;

const GET_REGISTRATION_STATUS = gql`
  query schoolOrDistrictRegistration($registrationId: ID!) {
    schoolOrDistrictRegistration(id: $registrationId) {
      id
      ncesSchoolId
      ncesDistrictId
      numberOfSchools
      districtName
      contactPhoneNumber
      registrant {
        firstName
        lastName
        email
      }
      setupProgress {
        areSchoolsActivated
        schoolsActivatedAt
        isSiteLinked
        siteLinked
        siteLinkedAt
        haveStaffBeenLoaded
        staffLoadedAt
        haveStaffBeenEmailed
        staffEmailedAt
        haveStaffBeenTrained
        staffTrainedAt
        haveOrgsBeenEmailed
        orgsEmailed
        orgsEmailedAt
        haveParentsBeenLoaded
        parentsLoadedAt
        haveParentsBeenEmailed
        parentsEmailed
        parentsEmailedAt
        status
        createdAt
        updatedAt
      }
    }
  }
`;

const SetupContainer = ({
  history,
  location,
  registrationId,
  storeNcesDistrictId,
  storeNcesSchoolId,
  verifiedSchools,
}) => {
  const queryVariables = { registrationId };

  return registrationId ? (
    <Query
      query={GET_REGISTRATION_STATUS}
      variables={queryVariables}
      pollInterval={1000}
    >
      {({ loading, error, data, refetch }) => {
        if (loading) return <Spinner />;
        if (error) return `Error! ${error.message}`;

        const pathname = location.pathname.split('/');
        const route = `/${pathname[pathname.length - 1]}`;
        const steps = transformRegistrationStatus(data, route, history);
        const {
          setupProgress,
          ncesSchoolId,
          ncesDistrictId,
          numberOfSchools,
          districtName,
          registrant,
          contactPhoneNumber,
        } = data.schoolOrDistrictRegistration;

        storeNcesDistrictId(ncesDistrictId);
        storeNcesSchoolId(ncesSchoolId);

        return (
          <div
            style={{
              backgroundColor: '#f5f5f5',
              padding: '2rem 0',
              flex: '1 1 auto',
            }}
          >
            {/* TODO: Notification Container */}
            <div className="container" style={{ flex: '1 1 auto' }}>
              <div
                style={{
                  display: 'flex',
                  flexDirection: 'row',
                  justifyContent: 'space-around',
                }}
                onClick={() => refetch()}
              >
                <Stepper steps={steps} />
              </div>
              {SetupRouter(
                setupProgress,
                ncesSchoolId,
                ncesDistrictId,
                numberOfSchools,
                districtName,
                refetch,
                registrant,
                contactPhoneNumber,
                verifiedSchools
              )}
            </div>
          </div>
        );
      }}
    </Query>
  ) : (
    <noscript />
  );
};

const SetupRouter = (
  setupProgress,
  ncesSchoolId,
  ncesDistrictId,
  numberOfSchools,
  districtName,
  refetch,
  registrant,
  contactPhoneNumber,
  verifiedSchools
) => {
  const {
    areSchoolsActivated,
    haveStaffBeenLoaded,
    haveParentsBeenLoaded,
    haveOrgsBeenEmailed,
    haveStaffBeenEmailed,
    parentsEmailed,
    siteLinked,
    orgsEmailed,
  } = setupProgress;

  return (
    <React.Fragment>
      <Switch>
        <Route
          exact
          path="/onboarding/setup/school"
          render={() => (
            <SetupSchoolContainer
              areSchoolsActivated={areSchoolsActivated}
              ncesDistrictId={ncesDistrictId}
              numberOfSchools={numberOfSchools}
              registrant={registrant}
              contactPhoneNumber={contactPhoneNumber}
              verifiedSchools={verifiedSchools}
              isSiteLinked={
                siteLinked === 'visited' || siteLinked === 'confirmed'
              }
            />
          )}
        />
        <Route
          exact
          path="/onboarding/setup/staff"
          render={({ history }) => (
            <SetupStaffContainer
              haveStaffBeenLoaded={haveStaffBeenLoaded}
              haveStaffBeenEmailed={haveStaffBeenEmailed}
              ncesSchoolId={ncesSchoolId}
              districtName={districtName}
              registrant={registrant}
              contactPhoneNumber={contactPhoneNumber}
              history={history}
            />
          )}
        />

        <Route
          exact
          path="/onboarding/setup/organization"
          render={() => (
            <SetupOrganizationContainer
              haveOrgsBeenEmailed={haveOrgsBeenEmailed}
              ncesDistrictId={ncesDistrictId}
              haveStaffBeenEmailed={haveStaffBeenEmailed}
              isOrgComplete={
                orgsEmailed === 'visited' || orgsEmailed === 'confirmed'
              }
            />
          )}
        />
        <Route
          path="/onboarding/setup/parent"
          render={() => (
            <SetupParentContainer
              haveParentsBeenLoaded={haveParentsBeenLoaded}
              ncesSchoolId={ncesSchoolId}
              ncesDistrictId={ncesDistrictId}
              isParentsSetupCompleted={
                parentsEmailed === 'visited' || parentsEmailed === 'confirmed'
              }
            />
          )}
        />
        <Route
          path="/onboarding/setup/confirm"
          render={() => (
            <ConfirmSetupContainer
              ncesDistrictId={ncesDistrictId}
              setupProgress={setupProgress}
              refetchRegistration={refetch}
            />
          )}
        />
      </Switch>
    </React.Fragment>
  );
};

export default SetupContainer;



// WEBPACK FOOTER //
// ./src/Onboarding/Setup/containers/SetupContainer.jsx